import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header/Header.jsx';
import Hero from './components/Hero/Hero.jsx';
import WebDesignContent from './components/WebDesignContent/WebDesignContent.jsx';
import GraphicDesignContent from './components/GraphicDesignContent/GraphicDesignContent.jsx';
import Footer from './components/Footer/Footer.jsx';
import DesignDetail from './components/DesignDetail/DesignDetail.jsx';
import CharacterDesign from './components/CharacterDesign/CharacterDesign.jsx';
import AnimatedGifCards from './components/AnimatedGifCards/AnimatedGifCards.jsx';
import ThathaPuli from './components/ThathaPuli/ThathaPuli.jsx';
import LogoCreation from './components/LogoCreation/LogoCreation.jsx';
import Future from './components/Future/Future.jsx';
import ProcreateSpace from './components/ProcreateSpace/ProcreateSpace.jsx'
import ComicCards from './components/ComicCard/ComicCard.jsx';
import ComicScript from './components/ComicScript/ComicScript.jsx';
import PaintingsGallery from './components/PaintingsGallery/PaintingsGallery.jsx';
import BookCoversGallery from './components/BookCoversGallery/BookCoversGallery.jsx';
import IllustrationGallery from './components/IllustrationArt/IllustrationArt.jsx';
import MerchandisePage from './components/MerchandiseDesign/MerchandiseDesign.jsx';
import ComingSoon from './components/ComingSoon/ComingSoon.jsx';
import ProductLabelGallery from './components/ProductLabel/ProductLabel.jsx';
import DesignGallery from './components/MediaGallery/MediaGallery.jsx';
import BookIllustartion from './components/BookIllustration/BookIllustration.jsx'
import MalayalamMoviePosters from './components/MalayalamMoviePosters/MalayalamMoviePosters.jsx';
import CalendarPage from './components/CalendarPage/CalendarPage.jsx';
import ContactPage from './components/Contact/Contact.jsx';
import StoryboardGallery from './components/StoryboardGallery/StoryboardGallery.jsx';
import StoryboardDetail from './components/StoryboardDetail/StoryboardDetail.jsx';
import Flutter from './components/projects/Flutter/Flutter.jsx';
import DigikoProjectShowcase from './components/projects/Digiko/Digiko.jsx';
import ENirmitProjectShowcase from './components/projects/Enirmit/Enirmit.jsx';
import FarmsmojoProjectShowcase from './components/projects/Farmsmojo/Farmsmojo.jsx';
import StayMojoProjectShowcase from './components/projects/Staymojo/Staymojo.jsx';
import WhiteDentalProjectShowcase from './components/projects/Whitedentl/Whitedental.jsx';
import DrArpanaProjectShowcase from './components/projects/Gynaec/Gynaec.jsx';
import ErasmithProjectShowcase from './components/projects/Erasmith/Erasmith.jsx';
import HyphenProjectShowcase from './components/projects/HyphenSoftware/HyphenSoftware.jsx';
import OrbitalFoodProjectShowcase from './components/projects/Orbitalfood/Orbitalfood.jsx';
import MTRealityProjectShowcase from './components/projects/MTReality/MTReality.jsx';
import AwfismojoProjectShowcase from './components/projects/Awfismojo/Awfismojo.jsx';
import AICollaborateProjectShowcase from './components/projects/AICollaborate/AICollaborate.jsx';
import AllProjects from './components/AllProjects/AllProjects.jsx';
import NamePlaceThing from './components//projects/NamePlaceThing/NamePlaceThing.jsx';
import FarmsmojoPortfolio from './components/projects/FarmsmojoFigma/FarmsmojoFigma.jsx';
import DatingAppCaseStudy from './components/projects/DatinappFigma/DatingappFigma.jsx';
import SponsorshipDeck from './components/PPT/DaveJenkinsCaseStudy-Compact.jsx';
import PresentationDesign from './components/PresentationDesign/PresentationDesign.jsx';
import CmpInvester from './components/CMPInvestorDeck/CMPInvestorDeck.jsx';
import AlzaferHospital from './components/AlzaferHospitalCaseStudy/AlzaferHospitalCaseStudy.jsx';
import GuessTheImageLanding from './components/projects/Guesstheimage/Guesstheimage.jsx';
import KingsCourtLanding from './components/projects/KingsCourt/KingsCourt.jsx';
import GridPlugin from './components/projects/GridPlugin/GridPlugin.jsx';
import FeedbackPlugin from './components/projects/FeedbackPlugin/FeedbackPlugin.jsx';
import MasonryGalleryPro from './components/projects/MasonryGalleryPro/MasonryGalleryPro.jsx';

function App() {
  const [mode, setMode] = useState('graphic');
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 30 - 15,
        y: (e.clientY / window.innerHeight) * 30 - 15,
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <div style={{background: 'linear-gradient(135deg, #000000 0%, #581c87 50%, #000000 100%)', minHeight: '100vh'}}>
            <Header
              mode={mode}
              setMode={setMode}
              menuOpen={menuOpen}
              setMenuOpen={setMenuOpen}
              scrolled={scrolled}
            />
            <Hero mode={mode} mousePosition={mousePosition} />
            {mode === 'web' ? <WebDesignContent onModeChange={setMode} /> : <GraphicDesignContent onModeChange={setMode} />}
            <Footer mode={mode} />
          </div>
        } />
        <Route path="contact" element={<ContactPage />} />
        <Route path="/design/:id" element={<DesignDetail />} />
        <Route path="/character-design" element={<CharacterDesign />} />
        <Route path="/animatedgiftcard" element={<AnimatedGifCards />} />
        <Route path="/thatapuli" element={<ThathaPuli />} />
        <Route path="/logo-creation" element={<LogoCreation />} />
        <Route path="/future" element={<Future />} />
        <Route path="/procreate-space" element={<ProcreateSpace />} />
        <Route path="/comic-card" element={<ComicCards/>}/>
        <Route path="/comic-script" element={<ComicScript/>}/>
        <Route path="/painting-portfolio" element={<PaintingsGallery/>}/>
        <Route path="/book-covers" element={<BookCoversGallery/>} />
        <Route path="/illustrations" element={<IllustrationGallery/>} />
        <Route path="/merchandise-design" element={<MerchandisePage/>} />
        <Route path="/coming-soon" element={<ComingSoon/>} />
        <Route path="/product-label" element={<ProductLabelGallery/>} />
        <Route path="/media" element={<DesignGallery/>} />
        <Route path="/book-illustration" element={<BookIllustartion/>} />
        <Route path="/malayalam-movie-posters" element={<MalayalamMoviePosters/>} />
        <Route path="/calendar-2026" element={<CalendarPage/>} />
        <Route path="/storyboard" element={<StoryboardGallery/>} />
        <Route path="/storyboard/:id" element={<StoryboardDetail/>} />
        <Route path="/flutter" element={<Flutter/>} />
        <Route path="/web-marketing" element={<DigikoProjectShowcase/>} />
        <Route path="/erp-system" element={<ENirmitProjectShowcase/>} />
        <Route path="/ecommerce" element={<FarmsmojoProjectShowcase/>} />
        <Route path="/hotel-booking" element={<StayMojoProjectShowcase/>} />
        <Route path="/dental-service" element={<WhiteDentalProjectShowcase/>} />
        <Route path="/healthcare-service" element={<DrArpanaProjectShowcase/>} />
        <Route path="/technology-service" element={<ErasmithProjectShowcase/>} />
        <Route path="/integration-platform" element={<HyphenProjectShowcase/>} />
        <Route path="/food-brand" element={<OrbitalFoodProjectShowcase/>} />
        <Route path="/real-estate" element={<MTRealityProjectShowcase/>} />
        <Route path="/food-ordering" element={<AwfismojoProjectShowcase/>} />
        <Route path="/ai-solutions" element={<AICollaborateProjectShowcase/>} />
        <Route path="/all-projects" element={<AllProjects/>} />
        <Route path="/nameplacething" element={<NamePlaceThing/>} />
        <Route path="/farmsmojo-app" element={<FarmsmojoPortfolio/>} />
        <Route path="/dating-app" element={<DatingAppCaseStudy/>} />
        <Route path="/ppt" element={<PresentationDesign />} />
        <Route path="/ppt/dave-jenkins" element={<SponsorshipDeck />} />
        <Route path="/ppt/cmp-invester" element={<CmpInvester />} />
        <Route path="/ppt/alzafer-hospital" element={<AlzaferHospital />} />
        <Route path="/guess-the-image" element={<GuessTheImageLanding/>} />
        <Route path="/kingscourt" element={<KingsCourtLanding/>} />
        <Route path="/gridplugin" element={<GridPlugin/>} />
        <Route path="/feedbackplugin" element={<FeedbackPlugin/>} />
        <Route path="/masonrygallery" element={<MasonryGalleryPro/>} />
      </Routes>
    </Router>
  );
}

export default App;